import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'

const state = {
  userId: null,
  appId: null,
  formId: null,
  companyId: null,
  token: '',
  openId: '', // 客户门户传过来
  userInfo: null,
  company: null,
  canNavBack: true,
  companyList: [],
  activeApp: null,
  // 用户列表
  userList: [],

  // 角色列表
  roleList: [],

  // 组织架构
  organization: {},

  depInfo: {},

  // 接口返回需要显示的成员信息
  memberDetailMap: {},
  externalDetailMap: {},

  // 外部联系人
  externalList: [
    /**
     {
      "staffId":"12312312", //外部联系人Id
      "agreeFlag":0, //邀请人是否已经同意
      "orgUserName": "策略",
      "orgUserMobile": "18700000001",
      "orgName": "测试公司",
      "chargePersonName":"负责人名称",
      "labelList":[
        {
          "labelId":"1234", //标签Id
          "labelName":"", //标签名
          "color":"#132131" //颜色
        }
      ]
    }
     */
  ],
  // 外部联系人标签
  extLabelList: [],
  // 已离职员工
  leaveMemberList: [],
  // 已离职外部联系人
  leaveExternalList: [],

  // 用户管理员状态
  adminInfo: null,

  // 系统配置
  systemConfig: null,

  personalizedConfig: null,

  // 当前环境
  env: '',

  // 飞书key
  tenantKey: '',

  showDraggable: false,
  spacePages: [],

  showLoginDraggable: false,
  ymtNodeKey: '',
  ymtQrcode: '',

  showBack: 0, // 第三方进来后是否显示返回按钮

  pageTitle: '' // 页面标题
}

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

